
const window = require('window');

const assert = require('assert');

const _ = require('lodash');

const $ = require('rgs-jquery');


const GROUP_ATTR = 'data-alignment-group';
const DIMENSION_ATTR = 'data-alignment-dimension';
const DEBOUNCE = 300;


class DimensionAlignmentGroup {
	constructor (dimension, elements) {
		assert(
			_.includes(['width', 'height'], dimension),
			'`dimension` must be one of "width" or "height"'
		);

		this._dimension = dimension;
		this._elements = elements;
	}

	_estimateDimension (element) {
		const $clone = $(element).clone();

		$clone.css({
			visibility: 'hidden',
			width: '',
			height: '',
			maxWidth: '',
			maxHeight: '',
		});

		$('body').append($clone);

		const dimensionGetterMethodName = _.camelCase(`outer-${this._dimension}`);

		const dimensionValue = $clone[dimensionGetterMethodName]();

		$clone.remove();

		return dimensionValue;
	}

	_findMaxDimension () {
		return _(this._elements)
			.map(el => this._estimateDimension(el))
			.max();
	}

	_setElementDimension (el, value) {
		$(el)[this._dimension](value);
	}

	_setAllElementsDimension (value) {
		_.each(this._elements, el => {
			this._setElementDimension(el, value);
		});
	}

	update () {
		const max = this._findMaxDimension();
		this._setAllElementsDimension(max);
	}
}

class DimensionGroupsGroup {
	constructor (groups) {
		this._groups = groups;
	}

	update () {
		_.each(this._groups, g => g.update());
	}
}

$(function () {
	const groups = _($(`[${GROUP_ATTR}]`))
		.map(el => ({
			element: el,
			group: el.getAttribute(GROUP_ATTR),
			dimension: el.getAttribute(DIMENSION_ATTR),
		}))
		.groupBy('group')
		.mapValues(group => ({
			dimension: _.get(_.head(group), 'dimension'),
			elements: _.map(group, 'element'),
		}))
		.mapValues(({ dimension, elements }) => {
			return new DimensionAlignmentGroup(dimension, elements);
		})
		.value();

	const group = new DimensionGroupsGroup(groups);

	const update = _.debounce(() => {
		group.update();
	}, DEBOUNCE);

	update();

	$(window).on('resize.page-common.alignment.data-api', update);
});
